
import { getExtension, MimeType } from "./mimeTypes";
import { downloadBuffer, downloadUrl } from "./util";

export interface ITemplateBase {
  filename: string;
  mimeType: MimeType;
}
export interface ITemplateBuffer extends ITemplateBase {
  buffer: ArrayBuffer;
}
export interface ITemplateUrl extends ITemplateBase {
  url: string;
}
export type ITemplate = ITemplateBuffer | ITemplateUrl;

export function downloadTemplate(template: ITemplate) {
  if ('buffer' in template) {
    downloadBuffer(template.buffer, template.filename || 'Unnamed', getExtension(template.mimeType));
  } else if ('url' in template) {
    downloadUrl(template.url, template.filename || 'Unnamed', getExtension(template.mimeType));
  } else {
    console.error('No idea how to download this template:', template);
  }
}

export class TemplateHolder {
  public onChanged: () => void;
  public templates: ITemplate[] = [];
  public add(template: ITemplate): any {
    const filename = template.filename;
    const existing = this.templates.findIndex(t => t.filename === filename);
    if (existing !== -1) {
      this.templates[existing] = template;
      if (this.onChanged) this.onChanged();
      return;
    }
    this.templates.push(template);
    if (this.onChanged) this.onChanged();
  }
  public remove(name: string) {
    const index = this.templates.findIndex(t => t.filename === name);
    if (index !== -1) {
      this.templates.splice(index, 1);
      if (this.onChanged) this.onChanged();
    }
  }
  public clear() {
    this.templates = [];
    if (this.onChanged) this.onChanged();
  }
}

export const TEMPLATE_DROPZONES: Array<React.Component & { addTemplate: (template: ITemplate) => void }> = [];



// WEBPACK FOOTER //
// ./src/logic/templates.ts